import { IonCard } from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

const VehicleLinkAlert: React.FC = () => {
	const { t } = useTranslation('pages_notifications')

	return (
		<IonCard
			style={{ width: 'fit-content' }}
			className='vehicle-link-alert dark:bg-brand-primary-200-dark dark:text-white m-4'
		>
			<h1>{t('vehicleProblemDetected')}</h1>
		</IonCard>
	)
}
export default VehicleLinkAlert
